declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackCall(link: HTMLAnchorElement) {
  const phone = decodeURIComponent(link.getAttribute("href")?.replace(/^tel:/, "") ?? "");
  window.gtag?.("event", "call", { phone_number: phone });
}
